import { powerUpAlice } from '../../../../../../backend/store/playerProfile';
import Button from '../../button/Button';

const BUTTON_WIDTH = 326;
const BUTTON_OFFSET_X = 8;

export default class Alice extends Phaser.GameObjects.Container {
    private heroId: number;
    private avatar!: Phaser.GameObjects.Image;
    private damage!: Button;
    private critChance!: Button;
    private extraGold!: Button;
    private aura!: Button;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);

        this.heroId = 0;

        // this.setupAvatar();
        this.setupDamage();
        this.setupCritChance();
        this.setupExtraGold();
        this.setupAura()
    }

    // setupAvatar() {
    //     let x = 20;
    //     let y = 20;
    //     let frame = 'gui/footer/avatar_alice';

    //     this.avatar = this.scene.add.image(x, y, 'atlas', frame);
    //     this.avatar.setOrigin(0);
    //     this.add(this.avatar);
    // }

    setupDamage() {
        const w = this.scene.cameras.main.width / 2;
        const x = (w - BUTTON_WIDTH) / 2 + BUTTON_OFFSET_X;
        const y = 30;

        this.damage = new Button(this.scene, x, y, this.scene.cache.json.get('i18n')['damage'], 'damage_level', 'alice');
        this.add(this.damage);

        this.damage.on('click', this.onDamageClick, this);
    }

    setupCritChance() {
        const w = this.scene.cameras.main.width / 2;
        const x = w + (w - BUTTON_WIDTH) / 2 - BUTTON_OFFSET_X;
        const y = 30;

        this.critChance = new Button(this.scene, x, y, this.scene.cache.json.get('i18n')['crit_chance'], 'critical_chance_level', 'alice');
        this.add(this.critChance);

        this.critChance.on('click', this.onCritChanceClick, this);
    }

    setupExtraGold() {
        const w = this.scene.cameras.main.width / 2;
        const x = (w - BUTTON_WIDTH) / 2 + BUTTON_OFFSET_X;
        const y = 150;

        this.extraGold = new Button(this.scene, x, y, this.scene.cache.json.get('i18n')['extra_gold'], 'extra_gold_level', 'alice');
        this.add(this.extraGold);

        this.extraGold.on('click', this.onExtraGoldClick, this);
    }

    setupAura() {
        const w = this.scene.cameras.main.width / 2;
        const x = w + (w - BUTTON_WIDTH) / 2 - BUTTON_OFFSET_X;
        const y = 150;

        this.aura = new Button(this.scene, x, y, this.scene.cache.json.get('i18n')['aura'], 'aura_level', 'alice');
        this.add(this.aura);

        this.aura.on('click', this.onAuraClick, this);
    }

    onAuraClick() {
        powerUpAlice({ aura_level: 1 });
    }

    onDamageClick() {
        powerUpAlice({ damage_level: 1 });
    }

    onCritChanceClick() {
        powerUpAlice({ critical_chance_level: 1 });
    }

    onExtraGoldClick() {
        powerUpAlice({ extra_gold_level: 1 });
    }

    show() {
        this.setVisible(true);
        this.setActive(true);
    }

    hide() {
        this.setVisible(false);
        this.setActive(false);
    }
}
